/**
 * 跨页复用的纯 class 常量。
 *
 * 对照搬小书 `xhshub/apps/web/src/app/mobile/ui.ts`（它那边是
 * `rounded-card bg-surface p-4 space-y-2` + 阴影）。我们用的是 shadcn 的
 * `Card`：底色/圆角/竖向内边距（`py-(--card-spacing)`）都在基础类里，
 * **但横向内边距是由 CardHeader/CardContent 负责的** —— 直接用 `<Card>` 装
 * 自定义内容会贴边。所以所有卡片都套 `CARD` 补上横向留白。
 */

/** 卡片：补横向内边距（与 Card 基础类的竖向 padding 对齐）。 */
export const CARD = 'rounded-card px-(--card-spacing)';

/** 辅助说明文字 */
export const MUTED = 'text-muted-foreground text-footnote';

/** 更小的提示文字 */
export const HINT = 'text-muted-foreground text-caption1 leading-snug';

/** 卡片下方的说明（iOS 分组列表的 footer）：紧贴上一张卡片，左右与卡内文字对齐 */
export const FOOTNOTE = 'text-muted-foreground -mt-2 px-4 text-footnote leading-snug';

/** 会对齐 / 会刷新的数字用等宽，避免宽度抖动 */
export const NUM = 'tabular-nums';
